<template>
  <v-container>
    <v-container id="regular-tables-view" tag="section">
      <v-tabs v-model="stab" color="primary accent-4">
        <v-tab
          v-for="(school, sindex) in schools"
          :key="sindex"
          @click="_selectSchool(school)"
          >{{ school.name }}</v-tab
        >
      </v-tabs>
      <v-tabs-items v-model="stab">
        <v-tab-item v-for="(school, ssindex) in schools" :key="ssindex">
          <employee-table
            :item="{ name: title, fbpath: collectionName }"
            :school="school"
          ></employee-table>
        </v-tab-item>
      </v-tabs-items>

      <div class="py-3" />
    </v-container>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");

export default {
  data: () => ({
    schools: null,
    stab: null,
    collectionName:'employees',
    title: 'Багш, aжилтан'
  }),
  components: {
    EmployeeTable: () => import("@/views/teacher/EmployeeTable"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "xxschool", "xxdepartment"]),
  },
  created() {
    this._read();
  },

  methods: {
    _selectSchool(school) {
      console.log(school);
      if (!school.employees) {
        school.ref
          .collection(this.collectionName)
          .get()
          .then((querySnapshot) => {
            {
              if (!school.employees) {
                school.employees = [];
                querySnapshot.forEach((doc) => {
                  let employee = doc.data();
                  employee.id = doc.id;
                  employee.ref = doc.ref;
                  school.employees.push(employee);
                });
              }
            }
          });
      }
    },
    _read() {
      fb.db
        .collection("schools")
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          {
            this.schools = [];
            querySnapshot.forEach((doc) => {
              let school = doc.data();
              school.id = doc.id;
              school.ref = doc.ref;
              this.schools.push(school);
              if (this.schools.length == 1) {
                this._selectSchool(this.schools[0]);
              }
            });
          }
        });
    },
  },
};
</script>
